import Immutable from 'immutable';
import * as types from './Layout.types';

const initialFields = {
    name: '',
    email: '',
    coupa_po: '',
    order_id: '',
    message: '',
    help_with_printing: 0,
    help_with_promotional: 0,
    help_with_apparel: 0,
    help_with_fitting: 0,
    help_with_other: 0,
    help_with_other_description: '',
    team_type: '',
    team_type_other: '',
    status: 1,
    openTickets: '',
    
    // New fitting
    fitting_how_many_people: '',
    fitting_apparel_type_scrubs: 0,
    fitting_apparel_type_polos: 0,
    fitting_apparel_type_jackets: 0,
    fitting_apparel_type_other: 0,
    fitting_apparel_type_other_description: '',
    fitting_style_men: 0,
    fitting_style_women: 0,
    fitting_style_both: 0,
    fitting_address: '',
    fitting_city: '',
    fitting_state: '',
    fitting_zip: '',
    fitting_department: '',
    fitting_floor: '',
    fitting_building_number: '',
};

const initialState = {
    fields: initialFields,
    isSending: false,
    files: [],
    fittingMonth: '',
    fittingDate: '',
    fittingReserved: [],
    checkingFitting: false
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.SEND_REQUEST:
            return state.setIn(['isSending'], true).toJS();

        case types.SEND_REQUEST_SUCCESS:
            return state.setIn(['isSending'], false)
                .setIn(['fields'], initialFields)
                .setIn(['files'], JSON.parse(action.payload.files))
                .setIn(['fittingMonth'], '')
                .setIn(['fittingDate'], '')
                .toJS();

        case types.SEND_REQUEST_ERROR:
            return state.setIn(['isSending'], false).toJS();

        case types.FETCH_HELP_REQUEST_OPEN_TICKETS:
            return state.toJS();

        case types.FETCH_HELP_REQUEST_OPEN_TICKETS_SUCCESS:
            return state.setIn(['openTickets'], action.payload).toJS();

        case types.FETCH_HELP_REQUEST_OPEN_TICKETS_ERROR:
            return state.toJS();

        case types.CHECK_FITTING:
            return state.setIn(['checkingFitting'], true).toJS();

        case types.CHECK_FITTING_SUCCESS:
            return state.setIn(['checkingFitting'], false)
                .setIn(['fittingReserved'], action.payload)
                .toJS();

        case types.CHECK_FITTING_ERROR:
            return state.setIn(['checkingFitting'], false).toJS();

        case types.SET_FIELD:
            return state.setIn(['fields', action.payload.field], action.payload.value).toJS();

        case types.ADD_FILE:
            return state.updateIn(['files'], (files) => {
                return files.push(action.payload);
            }).toJS();

        case types.REMOVE_FILE:
            return state.updateIn(['files'], (files) => {
                return files.delete(action.payload);
            }).toJS();

        case types.CLEAR_FILES:
            return state.updateIn(['files'], (files) => {
                return files.clear();
            }).toJS();

        case types.SET_FITTING_MONTH:
            return state.setIn(['fittingMonth'], action.payload).toJS();

        case types.SET_FITTING_DATE:
            return state.setIn(['fittingDate'], action.payload).toJS();

        case types.RESET_FIELDS:
            return state.setIn(['fields'], initialFields).toJS();

        default:
            return state.toJS();
    }
}